<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="5" :lg="5" :md="5" :sm="24">
            <a-form-item label="是否生效">
              <j-multi-select-tag
                @change="searchQuery"
                :options="[
                  {
                    label: '是',
                    value: '1'
                  },
                  {
                    label: '否',
                    value: '0'
                  }
                ]"
                placeholder="是否生效"
                type="checkbox"
                v-model="queryParam.enable"
              />
            </a-form-item>
          </a-col> -->
          <a-col :xl="5" :lg="5" :md="5" :sm="24">
            <a-form-item label="操作人">
              <j-dict-select-tag
                :dictCode="
                  `sys_user,realname,username,del_flag='0' and rel_tenant_ids='${this.$ls.get(
                    'TENANT_ID'
                  )}' order by realname`
                "
                pageSize="100"
                placeholder="请选择操作人"
                type="list"
                v-model="queryParam.createBy"
                @change="searchQuery"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="9" :lg="9" :md="9" :sm="24">
            <a-form-item label="加入时间">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择开始时间"
                class="query-group-cust"
                v-model="queryParam.createTime_begin"
                @change="searchQuery"
              ></j-date>
              <span class="query-group-split-cust"></span>
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择结束时间"
                class="query-group-cust"
                v-model="queryParam.createTime_end"
                @change="searchQuery"
              ></j-date>
            </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="5" :md="5" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <a-button type="primary" icon="download" @click="handleExportXls('告警白名单')">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        ref="superQueryModal"
        @handleSuperQuery="handleSuperQuery"
      ></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="alertRuleSlot" slot-scope="text, record">
          <a-button @click="showRuleDetail(record.groupCode)" type="link">{{ record.groupCode_dictText }}</a-button>
        </span>
      </a-table>
    </div>

    <iot-alert-whitelist-modal ref="modalForm" @ok="modalFormOk"></iot-alert-whitelist-modal>

    <alert-rule-modal ref="ruleModalForm"></alert-rule-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import IotAlertWhitelistModal from './modules/IotAlertWhitelistModal'
import AlertRuleModal from './modules/AlertRuleModal'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import { getAction } from '../../api/manage'

export default {
  name: 'IotAlertWhitelistList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    IotAlertWhitelistModal,
    AlertRuleModal
  },
  data() {
    return {
      description: '告警白名单管理页面',
      // 表头
      columns: [
        {
          title: '告警规则',
          align: 'center',
          dataIndex: 'groupCode',
          scopedSlots: { customRender: 'alertRuleSlot' }
        },
        {
          title: '操作人',
          align: 'center',
          sorter: true,
          dataIndex: 'createBy_dictText'
        },
        {
          title: '加入时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '持续时间(小时)',
          align: 'center',
          dataIndex: 'continueHours'
        },
        {
          title: '告警恢复时间',
          align: 'center',
          sorter: true,
          dataIndex: 'alertRecoverTime'
        },
        {
          title: '说明',
          align: 'center',
          dataIndex: 'remark'
        }
        // {
        //   title: '是否生效',
        //   align: 'center',
        //   sorter: true,
        //   dataIndex: 'enable',
        //   customRender: text => (text ? '是' : '否')
        // }
      ],
      url: {
        list: '/alert/iotAlertWhitelist/list',
        delete: '/alert/iotAlertWhitelist/delete',
        deleteBatch: '/alert/iotAlertWhitelist/deleteBatch',
        exportXlsUrl: '/alert/iotAlertWhitelist/exportXls',
        importExcelUrl: 'alert/iotAlertWhitelist/importExcel',

        ruleList: '/rule/alertRule/list'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.$set(this.dictOptions, 'enable', [
      { text: '是', value: 'Y' },
      { text: '否', value: 'N' }
    ])
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'ruleId', text: '告警规则', dictCode: '' })
      fieldList.push({ type: 'int', value: 'continueHours', text: '持续时间(小时)', dictCode: '' })
      fieldList.push({ type: 'datetime', value: 'alertRecoverTime', text: '告警恢复时间' })
      fieldList.push({ type: 'string', value: 'remark', text: '说明', dictCode: '' })
      fieldList.push({ type: 'switch', value: 'enable', text: '是否生效' })
      fieldList.push({ type: 'string', value: 'createBy', text: '创建人', dictCode: '' })
      fieldList.push({ type: 'datetime', value: 'createTime', text: '创建日期' })
      this.superFieldList = fieldList
    },
    async showRuleDetail(groupCode) {
      const response = await getAction(this.url.ruleList, { groupCode: groupCode })
      if (response.success && response.result.records.length > 0) {
        this.$refs.ruleModalForm.edit(response.result.records[0])
        this.$refs.ruleModalForm.title = '详情'
        this.$refs.ruleModalForm.disableSubmit = true
      }
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
